import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  FetchStudBookHorseByOwnerBreederthunk,
  FetchStudBookHorseByOwnerthunk,
} from "../Redux/StudBook/StudBookAction";
import {
  emptyPage,
  incrementPageOwnerDetails,
  resetSearch,
} from "../Redux/StudBook/StudBookSlice";
import { Link } from "react-router-dom";
import SubmitBtn from "../components/SubmitBtn";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import HorseCard from "../components/HorseCard";
import { FetchStudOwnerByIdthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import SectionTitle from "../components/SectionTitle";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import { iconContainer, noDataCard, showIconsContainer } from "../common/cssclasses";

const OwnerDetailsPage = () => {
  const dispatch = useDispatch();

  const ownerData = useRef({});

  ownerData.current = useLocation().state;
  console.debug("ownerData.current", ownerData.current);

  const {
    studBookLoading,
    //studBookData,
    studBookOwnerDetailsData,
    stateShowMoreButtonHorse,
    totalCountOwnerDetails,
    pageOwnerDetails,
    take,
    currentLanguage,
    studBookOwnerDetailsStateNoDataFound,
  } = useSelector((state) => state.studBookSlice);

  const { studOwnerByIdData } = useSelector((state) => state.ownerProfileSlice);
  const { translate } = useTranslate();

  const [HorsesOwnedHovered, setHorsesOwnedHovered] = useState(false);
  const [HorsesOwnedActive, setHorsesOwnedActive] = useState(true);

  const [HorsesBredsHovered, setHorsesBredsHovered] = useState(false);
  const [HorsesBredsActive, setHorsesBredsActive] = useState(false);

  const [selectedSearchType, setSelectedSearchType] = useState(1);

  const navigate = useNavigate();

  const handleSelectedSearchType = (e) => {
    setSelectedSearchType(e);
    dispatch(resetSearch());
  };

  useEffect(() => {
    if (pageOwnerDetails === 0) {
      dispatch(emptyPage());
      return;
    }

    let params = {
      ownerId: !!ownerData.current && ownerData.current.id,
      skip: (pageOwnerDetails - 1) * take,
      take,
      langauge: currentLanguage,
    };
    if (selectedSearchType === 1) {
      dispatch(FetchStudBookHorseByOwnerthunk(params));
    }
    if (selectedSearchType === 2) {
      dispatch(FetchStudBookHorseByOwnerBreederthunk(params));
    }
  }, [pageOwnerDetails, currentLanguage, ownerData.current]);

  useEffect(() => {
    let params = {
      id: !!ownerData.current && ownerData.current.id,
      langauge: currentLanguage,
    };
    dispatch(FetchStudOwnerByIdthunk(params));
  }, [ownerData.current]);

  const TabStyle = {
    display: "block",
    marginRight: -10,
    marginLeft: -10,
    marginTop: 6,
    padding: "10px 20px",
    textAlign: "center",
    background: "rgba(0,0,0,0.08)",
    cursor: "pointer",
    color: "#000",
    transition: "all 300ms",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  };

  const handelShowMore = async () => {
    dispatch(incrementPageOwnerDetails());
  };

  return (
    <React.Fragment>
      <>
        <div className="row   rtl ">
          <h2 className="col-lg-6 col-md-6 col-sm-12  text-start bold rtl capatalise">
            {studOwnerByIdData.length > 0 ?
              <>
                {!(studOwnerByIdData[0]?.ownerStudType == 'مربط' || studOwnerByIdData[0]?.ownerStudType == 'Stud') ?
                  <>
                    {ownerData?.current?.name}
                  </>
                  :
                  <>
                    {studOwnerByIdData[0].ownerName}
                  </>

                }

              </>
              :
              <>

                {!!ownerData.current && ownerData.current.name}
              </>
            }

          </h2>
          {studOwnerByIdData.length > 0 &&
            studOwnerByIdData.map((item, i) => (
              ((item.ownerStudType == 'مربط' || item.ownerStudType == 'Stud') && i < 1) ?

                <><h4
                  key={i}
                  className="col-lg-6 col-md-6 col-sm-12  text-md-end text-start bold rtl capatalise C89C66 "

                >
                  {studOwnerByIdData[0].ownerName}
                </h4>
                </>
                :
                <>

                  {(item.ownerStudType == 'المالك' || item.ownerStudType == 'Owner') &&
                    <h4
                      key={i}
                      className="col-lg-6 col-md-6 col-sm-12  text-md-end text-start bold rtl capatalise  C89C66 "

                    >
                      {studOwnerByIdData[0].ownerName}
                    </h4>
                  }
                </>
            ))}
          <div className={showIconsContainer}>
            <div className={iconContainer}>
              <i
                className="fa fa-user C89C66"
              ></i>
              <span> {studOwnerByIdData.length > 0 ? <>
                {translate("web.regno", "regno")}{" "}
                {ownerData?.current?.ownerId}
              </> : <>
                {translate("web.regno", "regno")}{" "}
                {!!ownerData.current && ownerData.current.ownerId}</>}
              </span>
            </div>
            {!!ownerData.current.nationality &&
              <div className={iconContainer}>
                <i className="fa-solid fa-earth-americas C89C66"></i>
                <span>
                  {ownerData.current.nationality}
                </span>
              </div>
            }
          </div>


          <div className="col-md-12 col-sm-12   rtl">
            {studOwnerByIdData.length > 0 &&
              studOwnerByIdData.map((item, i) => (
                ((item.ownerStudType == 'مربط' || item.ownerStudType == 'Stud') && i < 1) ?
                  <>
                    {(item.ownerStudType == 'مربط' || item.ownerStudType == 'Stud') &&
                      <div
                        key={i}
                        className="btn btn-outline-danger mb-main"
                        onClick={() => {
                          navigate("/ownerdetails", {
                            state: {
                              id: item.ownerStudId,
                              name: item.ownerStudName,
                              numberofHorsesBred: item.numberofHorsesBred,
                              numberofHorsesOwned: item.numberofHorsesOwned,
                              nationality: item.nationality,
                              ownerId: item.ownerStudNum,
                            },
                          });
                        }}
                      >
                        {item.ownerStudNum}
                        {" - "}
                        {item.ownerStudName} ({item.ownerStudType})
                      </div>
                    }
                  </>
                  :
                  <>
                    {(item.ownerStudType == 'المالك' || item.ownerStudType == 'Owner') &&
                      <div
                        key={i}
                        className="btn btn-outline-danger mb-main"
                        onClick={() => {
                          navigate("/ownerdetails", {
                            state: {
                              id: item.ownerStudId,
                              name: item.ownerStudName,
                              numberofHorsesBred: item.numberofHorsesBred,
                              numberofHorsesOwned: item.numberofHorsesOwned,
                              nationality: item.nationality,
                              ownerId: item.ownerStudNum,
                            },
                          });
                        }}
                      >
                        {translate('web.exploreOwnerHorses', 'Explore Owner Horses')}
                      </div>
                    }
                  </>
              ))}

          </div>

          <div className="col-md-12 col-sm-12   rtl">
            {studOwnerByIdData?.length > 0 &&
              studOwnerByIdData.map((item, i) => (
                ((item.ownerStudType == 'مربط' || item.ownerStudType == 'Stud') && (i < 1)) ?
                  <>
                    {(item.ownerStudType == 'مربط' || item.ownerStudType == 'Stud') &&
                      <SectionTitle ish3 noMargin isContainer={false} section_name={translate('web.ownerHorses', 'Owner Horses')} />
                    }
                  </>
                  :
                  <>
                    {(item.ownerStudType == 'المالك' || item.ownerStudType == 'Owner') &&
                      <SectionTitle ish3 noMargin isContainer={false} section_name={translate('web.studHorses', 'Stud Horses')} />
                    }
                  </>
              ))}
          </div>


          <div
            className={'col-6  text-center pe-0 mb-main'}
            style={{ cursor: 'pointer' }}
            id="second_most_used_services"
            onClick={() => {
              setHorsesOwnedActive(true);
              setHorsesBredsActive(false);
              handleSelectedSearchType(1);
            }}
          >
            <span className={`${HorsesOwnedActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>
              {translate("web.horsesOwned", "Horses Owned")} {!!ownerData.current &&
                " " + ownerData.current.numberofHorsesOwned}</span>
            <div className="service_bar_underline" style={HorsesOwnedActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
          </div>
          <div
            className={'col-6 text-center ps-0 mb-main'}
            style={{ cursor: 'pointer' }}
            id="second_most_used_services"
            onClick={() => {
              setHorsesOwnedActive(false);
              setHorsesBredsActive(true);
              handleSelectedSearchType(2);
            }}
          >
            <span className={`${HorsesBredsActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>
              {translate("web.horsesBreds", "horsesBreds")}  {!!ownerData.current &&
                " " + ownerData.current.numberofHorsesBred}</span>
            <div className="service_bar_underline" style={HorsesBredsActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
          </div>

          {!!studBookOwnerDetailsData &&
            studBookOwnerDetailsData.length > 0 &&
            studBookOwnerDetailsData.map((item, i) => (
              <HorseCard isArabicClass={true} item={item} i={i} />
            ))}

          {studBookOwnerDetailsStateNoDataFound && (
            <div className="col-12">
              <div className={noDataCard}>
                {translate("web.nodataFound", "No Data Found !")}
              </div>
            </div>
          )}

          <div
            className="col-lg-12 col-md-12 col-sm-12 text-center row"
          >
            {!studBookLoading &&
              !!studBookOwnerDetailsData &&
              studBookOwnerDetailsData.length > 0 ? (
              <div className="mx-auto w-unset">
                <NewActionButton
                  disabled={stateShowMoreButtonHorse}
                  onClick={handelShowMore}
                  text={`
                        ${translate("web.showMore", "Show More")} (${studBookOwnerDetailsData.length
                    } ${translate("web.of", "Of")} ${totalCountOwnerDetails})`}
                />
              </div>
            ) : (
              ""
            )}
            {studBookLoading && <Loader />}
          </div>
        </div>
      </>
    </React.Fragment>
  );
};

export default OwnerDetailsPage;
